import PaneProps from './PaneProps'

let KendoSplitterPane = {
    name: 'kendo-splitter-pane',
    render () {
        return null
    },
    mixins: [PaneProps]
}

export default KendoSplitterPane


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoSplitter/KendoSplitterPane.js